<template>
    <v-layout row wrap>
        <v-flex md6 sm12 v-if='requests' v-for="request of requests" :key="'request-' + request.id">
            <request-card v-if="request" show-update-time :selectable="false" hide-actions hide-rejected-counter
                          :item="request" @updateTime="(hour) => updateTime(request,hour)"/>
        </v-flex>
        <v-flex xs12>
            <v-layout justify-end>
                <v-btn flat large color="primary" @click="$emit('updateStepper')">Next</v-btn>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import RequestCard from "@/components/wasilni/RequestCard";

    export default {
        name: "RequestsEditor",
        components: {RequestCard},
        props: {
            requests: {
                type: Array,
                required: true
            }
        },
        methods: {
            updateTime(item, hour) {
                console.log(hour);
            },
        }
    }
</script>

<style scoped>

</style>